import React from 'react';
import {
  Button,
  TextField,
  Typography,
  Paper,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  IconButton,
  Grid,
  Chip,
} from '@material-ui/core';
import { Add as AddIcon, Delete as DeleteIcon, Warning as WarningIcon } from '@material-ui/icons';

const COLORS = {
  primary: '#455a64',
  light: '#f5f5f5',
  border: '#cfd8dc',
  action: '#FF5246',
};

const formatCurrencyInput = value => {
  if (!value && value !== 0) {
    return '';
  }
  const numValue = typeof value === 'string' ? parseFloat(value) : value;
  if (Number.isNaN(numValue)) {
    return '';
  }
  return numValue.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
};

const Penalidades = ({ formData, addPenalty, removePenalty, updatePenalty, classes, disabled = true }) => {
  return (
    <div className={classes.sectionGap} style={{ opacity: disabled ? 0.6 : 1 }}>
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'flex-start',
          marginBottom: 20,
        }}
      >
        <div>
          <Typography variant="h6">Penalidades</Typography>
          <Typography variant="body2" color="textSecondary">
            {disabled
              ? 'Em breve - funcionalidade será ativada em um próximo momento'
              : 'Configure penalidades por inadimplência ou churn'}
          </Typography>
        </div>
        <Button
          variant="contained"
          startIcon={<AddIcon />}
          onClick={addPenalty}
          disabled={disabled}
          style={{
            backgroundColor: disabled ? '#bdbdbd' : COLORS.action,
            color: '#fff',
            textTransform: 'none',
            boxShadow: 'none',
            cursor: disabled ? 'not-allowed' : 'pointer',
          }}
        >
          Adicionar Penalidade
        </Button>
      </div>

      {formData.penalties.length > 0 && (
        <div style={{ marginBottom: 24 }}>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: 8,
              marginBottom: 12,
              paddingBottom: 8,
              borderBottom: `2px solid ${COLORS.primary}`,
            }}
          >
            <WarningIcon style={{ color: COLORS.primary, fontSize: 20 }} />
            <Typography variant="subtitle1" style={{ fontWeight: 600, color: COLORS.primary }}>
              Penalidades Configuradas
            </Typography>
            <Chip
              label={formData.penalties.length}
              size="small"
              style={{
                backgroundColor: COLORS.primary,
                color: '#fff',
                height: 20,
                fontSize: 11,
              }}
            />
          </div>
          <div>
            {formData.penalties.map((penalty, index) => (
              <Paper
                key={penalty.id || `penalty-${index}`}
                variant="outlined"
                style={{
                  padding: 16,
                  marginBottom: index === formData.penalties.length - 1 ? 0 : 12,
                  backgroundColor: '#fff',
                  border: `1px solid ${COLORS.border}`,
                  borderRadius: 8,
                }}
              >
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    marginBottom: 12,
                  }}
                >
                  <Typography variant="body2" style={{ fontWeight: 600, color: '#555' }}>
                    Penalidade #{index + 1}
                  </Typography>
                  <IconButton
                    onClick={() => removePenalty(index)}
                    size="small"
                    style={{ color: '#999' }}
                    disabled={disabled}
                  >
                    <DeleteIcon fontSize="small" />
                  </IconButton>
                </div>
                <Grid container spacing={2}>
                  <Grid item xs={12} md={12}>
                    <TextField
                      label="Nome da Penalidade"
                      value={penalty.name || ''}
                      onChange={e => updatePenalty(index, 'name', e.target.value)}
                      placeholder="Ex: Penalidade por inadimplência"
                      fullWidth
                      size="small"
                      variant="outlined"
                      required
                      disabled={disabled}
                    />
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <FormControl fullWidth size="small" variant="outlined" disabled={disabled}>
                      <InputLabel>Motivo</InputLabel>
                      <Select
                        value={penalty.type}
                        label="Motivo"
                        onChange={e => updatePenalty(index, 'type', e.target.value)}
                        disabled={disabled}
                      >
                        <MenuItem value="">Selecione</MenuItem>
                        <MenuItem value="non_payment">Inadimplência</MenuItem>
                        <MenuItem value="churn">Churn</MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <FormControl fullWidth size="small" variant="outlined" disabled={disabled}>
                      <InputLabel>Tipo</InputLabel>
                      <Select
                        value={penalty.unit}
                        label="Tipo"
                        onChange={e => updatePenalty(index, 'unit', e.target.value)}
                        disabled={disabled}
                      >
                        <MenuItem value="percentage">Percentual (%)</MenuItem>
                        <MenuItem value="fixed">Valor Fixo (R$)</MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} md={4}>
                    {penalty.unit === 'fixed' ? (
                      <TextField
                        label="Valor (R$)"
                        value={formatCurrencyInput(penalty.value)}
                        onChange={e => {
                          const rawValue = e.target.value.replace(/\D/g, '');
                          const numericValue = rawValue ? parseInt(rawValue, 10) / 100 : '';
                          updatePenalty(index, 'value', numericValue);
                        }}
                        placeholder="Ex: 1.500,00"
                        fullWidth
                        size="small"
                        variant="outlined"
                        disabled={disabled}
                        InputProps={{
                          startAdornment: <span style={{ marginRight: 4, color: '#666' }}>R$</span>,
                        }}
                      />
                    ) : (
                      <TextField
                        label="Valor (%)"
                        type="number"
                        value={penalty.value}
                        onChange={e => updatePenalty(index, 'value', e.target.value)}
                        placeholder="Ex: 10"
                        fullWidth
                        size="small"
                        variant="outlined"
                        disabled={disabled}
                        InputProps={{
                          endAdornment: <span style={{ marginLeft: 4, color: '#666' }}>%</span>,
                          inputProps: { step: '0.01', min: 0, max: 100 },
                        }}
                      />
                    )}
                  </Grid>
                </Grid>
              </Paper>
            ))}
          </div>
        </div>
      )}

      {formData.penalties.length === 0 && (
        <div
          style={{
            textAlign: 'center',
            padding: 48,
            backgroundColor: '#fafafa',
            borderRadius: 8,
            border: '1px dashed #ddd',
          }}
        >
          <WarningIcon style={{ fontSize: 48, opacity: 0.3, marginBottom: 16, color: '#666' }} />
          <Typography variant="body1" style={{ color: '#666' }}>
            {disabled ? 'Funcionalidade em desenvolvimento.' : 'Nenhuma penalidade configurada.'}
          </Typography>
          <Typography variant="body2" style={{ marginTop: 8, color: '#999' }}>
            {disabled
              ? 'Em breve você poderá configurar penalidades por inadimplência ou churn.'
              : 'Clique em Adicionar Penalidade para começar.'}
          </Typography>
        </div>
      )}
    </div>
  );
};

export default Penalidades;
